export default __webpack_public_path__ + "static/media/styles.module.d9aeeb07.less";